import Vue from "vue";

// axios
import axios from "axios";

const baseUrl = process.env.VUE_APP_BASE_URL;

axios.defaults.baseURL = `${baseUrl}/api/`;

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  baseUrl: `${baseUrl}/api/`,
  // timeout: 10000,
  // headers: {'X-Custom-Header': 'foobar'}
});

Vue.prototype.$http = axiosIns;

export default axiosIns;
